import { C as CosmosIconStar$1, d as defineCustomElement$1 } from './p-CeMND92U.js';

const CosmosIconStar = CosmosIconStar$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStar, defineCustomElement };
